import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Get in touch 💼`}</h2>
    <a href='https://www.linkedin.com/in/ng-gia-bao-128316166/'>
  <img src='https://image.flaticon.com/icons/png/512/145/145807.png' width='50' />
    </a>{" "}
    <a href='https://github.com/baobaoack000'>
  <img src='https://image.flaticon.com/icons/png/512/733/733553.png' width='50' />
    </a>{" "}
    <a href='mailto:baobaoack000@gmail.com'>
  <img src='https://image.flaticon.com/icons/png/512/732/732200.png' width='50' />
    </a>
    <p><strong parentName="p">{`Say `}<a parentName="strong" {...{
          "href": "https://www.facebook.com/BaoHotSauce21"
        }}>{`Hi`}</a>{` or find me on other platforms:
`}<a parentName="strong" {...{
          "href": "https://www.linkedin.com/in/ng-gia-bao-128316166/"
        }}>{`LinkedIn`}</a>{` & `}<a parentName="strong" {...{
          "href": "mailto:baobaoack000@gmail.com"
        }}>{`Gmail`}</a>{`
& `}<a parentName="strong" {...{
          "href": "https://github.com/baobaoack000"
        }}>{`Github`}</a>{`.`}</strong></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      